// Determine environment from the host: QA and prod are built from the same branch,
// so a hard-coded flag always points one of them at the wrong API.
const host = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalhost = host === 'localhost' || host === '127.0.0.1';
const isDev = host.startsWith('qa.');
const isProd = !isLocalhost && !isDev;

// Base URLs based on environment
export const BASE_URL = isLocalhost
  ? `${process.env.REACT_APP_BASE_URL_LOCAL}` // Localhost
  : isProd
    ? `${process.env.REACT_APP_BASE_URL_PROD}` // Production
    : `${process.env.REACT_APP_BASE_URL_DEV}`; // Development

export const DIS_BASE_URL = isLocalhost
  ? `${process.env.REACT_APP_DIS_BASE_URL_LOCAL}` // Localhost
  : isProd
    ? `${process.env.REACT_APP_DIS_BASE_URL_PROD}` // Production
    : `${process.env.REACT_APP_DIS_BASE_URL_DEV}`; // Development

console.log(`Running in ${isProd ? 'Production' : isDev ? 'Development' : 'Localhost'} mode`);
console.log(`Base URL: ${BASE_URL}`);
console.log(`Dispatch URL: ${process.env.REACT_APP_BASE_URL_LOCAL}`);
console.log(`Dispatch URL: ${process.env.REACT_APP_BASE_URL_PROD}`);
console.log(`Dispatch URL: ${process.env.REACT_APP_BASE_URL_DEV}`);
